import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";

import { useCallback, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import getTableData from "./formatTableData";
import CommonSelect from "components/CommonSelect/select";
import { getCatalogoReportType } from "rest/requests";
import { useEffect } from "react";
import { findAuditReport } from "rest/requests";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { getExcelData } from "./getExcelData";

function SecurityReportQueries() {
  const [reports, setReports] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);
  const [selectedReportTypes, setSelectedReportTypes] = useState([]);
  const [ip, setIp] = useState("");
  const [user, setUser] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const getReportTypes = useCallback(async () => {
    setReportTypes(await getCatalogoReportType());
  }, []);

  const formatDate = (date) => {
    // : param date = yyyy-mm-dd
    // returns dd/mm/yyyy
    if (date) {
      const _temp = date.split("-");
      return _temp[2] + "/" + _temp[1] + "/" + _temp[0];
    } else {
      return null;
    }
  };

  const getReport = useCallback(async () => {
    setReports(
      await findAuditReport(
        selectedReportTypes,
        user,
        ip,
        formatDate(startDate),
        formatDate(endDate)
      )
    );
  }, [selectedReportTypes, user, ip, startDate, endDate]);

  useEffect(() => {
    getReportTypes();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TitleCustom
        title={"Consulta de Reportes"}
        excelData={getExcelData(reports, reportTypes)}
        excelName={"Consulta_de_Reportes.xlsx"}
        showChart={false}
        setShowChart={null}
      ></TitleCustom>
      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container>
          <Grid item padding={1} lg={4} xs={12}>
            <CommonSelect
              data={reportTypes}
              onChange={(selectedValue) => setSelectedReportTypes(selectedValue)}
              label={"Tipo de Reporte"}
            ></CommonSelect>
          </Grid>
          <Grid item padding={1} lg={4} xs={12}>
            <MDInput
              variant="outlined"
              type="text"
              label="IP"
              value={ip}
              fullWidth={true}
              onChange={(event) => setIp(event.target.value)}
            ></MDInput>
          </Grid>
          <Grid item padding={1} lg={4} xs={12}>
            <MDInput
              variant="outlined"
              type="text"
              label="Usuario"
              value={user}
              fullWidth={true}
              onChange={(event) => setUser(event.target.value)}
            ></MDInput>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item padding={1} lg={4} xs={12}>
            <MDInput
              variant="outlined"
              type="date"
              label=""
              value={startDate}
              fullWidth={true}
              onChange={(event) => setStartDate(event.target.value)}
              helperText="Fecha de Inicio"
            ></MDInput>
          </Grid>
          <Grid item padding={1} lg={4} xs={12}>
            <MDInput
              variant="outlined"
              type="date"
              label=""
              value={endDate}
              fullWidth={true}
              onChange={(event) => setEndDate(event.target.value)}
              helperText="Fecha Fin"
            ></MDInput>
          </Grid>
        </Grid>
        <MDButton color="success" onClick={() => getReport()}>
          Buscar
        </MDButton>
      </MDBox>
      <br></br>

      <DataTable table={getTableData(reports, reportTypes)} canSearch={true} />

      <Footer />
    </DashboardLayout>
  );
}

export default SecurityReportQueries;
